module.exports = __webpack_public_path__ + "img/compare-bulb.4ab73c7.webp";